import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

import { onDoCreatePin } from '@/redux/pin';
import { authStorage, encrypt, parseJson } from '@ajaibid/utils';

import { AES_ENCRYPTION_SECRET_KEY, COOKIE_KEY } from '@config/constanta';
import { CreatePinBox } from 'Component/PinBox';
import useAjaibConfig from '@/hooks/useAjaibConfig';
import useCreatePin from '@/hooks/useCreatePin';
import { styContainer } from './style';
import useEventTracker from './tracker';

function ConfirmPin() {
  const dispatch = useDispatch();
  const location = useLocation();
  const configLoading = useSelector((state) => state.config?.configLoading);
  const { eventConfirmPin6Digit } = useEventTracker();
  const isRenewPin = parseJson(Cookies.get(COOKIE_KEY.pin_need_change)) || false;

  const { config } = useAjaibConfig();
  const {
    success: createPinSuccess,
    error: createPinError,
    isLoading: createPinLoading,
  } = useCreatePin();

  const [errorMessage, setErrorMessage] = useState('');
  const is6Digit = config?.is_create_pin_6digit === '1';
  const pinToken = Cookies.get(COOKIE_KEY.pin_token);

  const firstPin = location?.state?.pin;
  if (!firstPin) {
    window.location.href = '/home';
  }

  const checkPin = (pin) => {
    if (firstPin === pin) {
      dispatch(onDoCreatePin({ new_pin: pin }, isRenewPin));
    } else {
      setErrorMessage('PIN tidak sesuai. Coba lagi.');
      if (is6Digit) {
        eventConfirmPin6Digit({
          'is successfull': 'false',
          'error response': 'PIN tidak sesuai',
        });
      }
    }
  };

  useEffect(() => {
    if (
      createPinSuccess?.is_valid === true ||
      createPinSuccess?.result === 'PIN Code already create'
    ) {
      if (pinToken) {
        const ciphertext = encrypt(pinToken, AES_ENCRYPTION_SECRET_KEY);
        authStorage.set('xyz', ciphertext);
      }
      if (is6Digit) {
        eventConfirmPin6Digit({
          'is successfull': 'true',
        });
      }
      Cookies.set(COOKIE_KEY.pin_need_change, false);
      window.location.href = '/home';
    }
  }, [createPinSuccess]);

  useEffect(() => {
    if (createPinError) {
      setErrorMessage(createPinError);
      if (is6Digit) {
        eventConfirmPin6Digit({
          'is successfull': 'false',
          'error response': createPinError,
        });
      }
    }
  }, [createPinError]);

  return (
    <div className={styContainer}>
      {!configLoading && (
        <CreatePinBox
          length={isRenewPin ? 6 : 4}
          title="Masukkan Ulang PIN"
          description={`PIN terdiri dari ${
            isRenewPin ? 6 : 4
          } angka yang akan kamu gunakan untuk membuka aplikasi dan melindungi datamu.`}
          onComplete={(value) => {
            checkPin(value);
          }}
          isLoading={createPinLoading}
          errorMessage={errorMessage}
        />
      )}
    </div>
  );
}

export default ConfirmPin;
